// src/utils/request.js
import axios from 'axios'

// 创建自定义Axios实例
const request = axios.create({
  // 自动为所有请求拼接基础路径，不同环境可动态切换
  baseURL: '/weixin/',
  // 设置全局请求超时时间，超过10秒自动中断请求
  timeout: 10000,
  // 配置默认请求头
  headers: {
    'Content-Type': 'application/json'
  }
})


request.interceptors.request.use(
  (config) => {
    // 从本地存储或Pinia中获取用户Token
    const token = localStorage.getItem('auth_token')
    if (token) {
      // 自动在请求头携带身份凭证
      config.headers.Authorization = `Bearer ${token}`
      console.log('-------------', config.headers)
    }
    return config
  },
  (error) => {
    // 提前捕获请求发送阶段的错误
    return Promise.reject(error)
  }
)

// request.interceptors.response.use(
//   (response) => {
//     const res = response.data
//     // 匹配后端约定的成功状态码，直接返回业务数据
//     if (res.code === 0 || res.code === 200) {
//       return res.data
//     }
//     // 处理业务逻辑错误，全局弹出提示
//     console.error(res.message || '请求失败')
//     return Promise.reject(new Error(res.message))
//   },
//   (error) => {
//     // 统一处理HTTP网络错误
//     if (error.response) {
//       const { status } = error.response
//       switch (status) {
//         case 401:
//           console.error('登录已过期，请重新登录')
//           sessionStorage.removeItem('auth_token')
//           // 自动跳转登录页
//           window.location.reload()
//           break
//         case 403:
//           console.error('无权限访问该资源')
//           break
//         case 500:
//           console.error('服务器内部异常')
//           break
//         default:
//           console.error(`请求错误，状态码：${status}`)
//       }
//     } else if (error.code === 'ECONNABORTED') {
//       console.error('请求超时，请检查网络')
//     } else {
//       console.error('网络连接失败')
//     }
//     return Promise.reject(error)
//   }
// )

export default request